import { CompaniesCard } from "./Settings.js";

/** 협력사·별칭 — 이름이 없으면 이관도 막힌다 (DATA-DICTIONARY §1). 대표가 직접 추가한다 */
export function Companies({ can }: { can: (p: string) => boolean }) {
  return (
    <>
      <div className="admin-head">
        <span className="navicon" aria-hidden="true">◎</span>
        <div>
          <h1>협력사</h1>
          <p className="page-desc" style={{ margin: 0 }}>
            회사명과 별칭은 하나의 이름공간입니다. 자동 생성은 없습니다 — 여기서 먼저 등록해야 이관·입고가 붙습니다.
          </p>
        </div>
      </div>
      <CompaniesCard canEdit={can("admin.users")} />
    </>
  );
}
